import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { isHotReloadEnabled } from 'vscode/vscode/vs/base/common/hotReload';
import 'vscode/vscode/vs/base/common/arrays';
import 'vscode/vscode/vs/base/common/observableInternal/derived';
import { autorunWithStore } from 'vscode/vscode/vs/base/common/observableInternal/autorun';
import 'vscode/vscode/vs/base/common/observableInternal/utils';
import 'vscode/vscode/vs/base/common/cancellation';
import { readHotReloadableExport } from 'vscode/vscode/vs/editor/browser/widget/diffEditor/utils';
import { IInstantiationService } from 'vscode/vscode/vs/platform/instantiation/common/instantiation';

function wrapInReloadableClass(getClass) {
    if (!isHotReloadEnabled()) {
        return getClass();
    }
    return class ReloadableWrapper extends BaseClass {
        constructor() {
            super(...arguments);
            this._autorun = undefined;
        }
        init() {
            this._autorun = autorunWithStore((reader, store) => {
                const clazz = readHotReloadableExport(getClass(), reader);
                store.add(this.instantiationService.createInstance(clazz));
            });
        }
        dispose() {
            this._autorun?.dispose();
        }
    };
}
let BaseClass = class BaseClass {
    constructor(instantiationService) {
        this.instantiationService = instantiationService;
        this.init();
    }
    init() { }
};
BaseClass = ( __decorate([
    ( __param(0, IInstantiationService))
], BaseClass));

export { wrapInReloadableClass };
